import PropTypes from "prop-types";

import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type cartesian
 */
const CartesianRender = ({ cartesianTemplate, onRemove, isEditable }) => {
  return (
    <BasicRender
      datasetTemplate={cartesianTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

CartesianRender.propTypes = {
  cartesianTemplate: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
};

export default CartesianRender;
